export default "__VITE_ASSET__ebb04052__"